module.exports = __webpack_public_path__ + "files/8f0f9d6b264098f202ede2f115e280b0.png";